export function initUserPopovers(parent) {
  if (parent) {
    $(parent).on('click', '.invite-user', handleClick);
  } else {
    $('.invite-user').on('click', handleClick);
  }
}

function handleClick(e) {
  e.preventDefault();
  const $this = $(this);
  $this.data('poppedover', !$this.data('poppedover'));
  $this.html(
    $this.data('poppedover')
      ? '<span class="icon icon_x"></span>'
      : '<span class="icon icon_sort_desc"></span>'
  );
  if ($this.data('popover')) return;

  $.get($this.data('url'), data => {
    $this.popover({
      html: true,
      content: data.body_html,
      title: data.title_html,
      container: 'body',
    });
    $this.popover('show');
  });
}
